import { FieldTypes } from '../../../constants/FieldTypes'
import { DropdownField, FormElement } from '../../../types/forms/fields'
import { EncounterType } from '../types/encounterType'

const prenatalVisitTypeField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  inputType: 'buttons',
  placeholder: 'Visit Type',
  options: [
    { id: 'routine', text: 'Routine' },
    { id: 'non-routine', text: 'Non-Routine' },
  ],
}

const ultrasoundScenarioTypeField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  inputType: 'buttons',
  placeholder: 'Scenario',
  options: [
    { id: 'provider-pocus', text: 'Provider-Performed POCUS' },
    { id: 'sonographer-study', text: 'Licensed Sonographer Study' },
  ],
}

export const examTypeConfigurationFields: Partial<
  Record<EncounterType, Record<string, FormElement>>
> = {
  [EncounterType.ANTEPARTUM]: {
    visitType: prenatalVisitTypeField,
  },
  [EncounterType.ULTRASOUND]: {
    scenarioType: ultrasoundScenarioTypeField,
  },
}
